// import React from "react"
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { Link } from "react-router-dom";

import Pagination from '@mui/material/Pagination';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";


import { format } from 'date-fns';
import moment from "moment";
import Pillchip from "../../components/Pillchip";
import ThreeDotsMenu from "../../components/ThreeDotsMenu";


const RepaymentSchedule = ({ loan, transactions}) => {

    //Pagination
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const { data: repaymentSchedule } = useQuery({
        queryKey: ['repayment-schedule', page],
        queryFn: async () => {
            const response = await authAxios.get(`/loans/repayment-schedules/?loan=${loan.id}&page=${page}`);
            setPageCount(response.data.page_count)
            return response.data.results
        },
    });

    const threeSubMenu = [
        // {
        //     id: 1,
        //     menu: "PDF",
        //     url: "/dashboard/invoicereport/",
        // }, 
        {
            id: 1,
            menu: "View",
            url: "/dashboard/transaction/",

        }, 
    ]; 

    return (
        <>
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>Installment</th>
                        <th>Due Date</th>
                        <th>Principal</th>
                        <th>Interest</th>
                        <th>Total Due</th>
                        <th>Paid</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                {repaymentSchedule && repaymentSchedule.map(schedule => (
                    <tbody key={schedule.id}>
                        <tr>
                            <td>{schedule.installment}</td>
                            {/* <td>{convertDateTime(schedule.date)}</td> */}
                            <td>{moment(schedule.due_date).format('DD-MM-YYYY')}</td>
                            <td>{Number(schedule.principal).toLocaleString('en-UK')}</td>
                            <td>{Number(schedule.interest).toLocaleString('en-UK')}</td>
                            <td>{Number(schedule.amount_due).toLocaleString('en-UK')}</td>
                            <td>{Number(schedule.amount_paid).toLocaleString('en-UK')}</td>
                            <td><Pillchip label={schedule.status_name} /></td>
                            <td className='styled-table-menu'>
                                <ThreeDotsMenu data={schedule} threeSubMenu={threeSubMenu} />
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
            
        <Pagination 
            className="custom-mui-pagination"
            count={pagecount} 
            page={page} 
            onChange={handlePageChange} 
        />

        </>

    );
  };
  
export default RepaymentSchedule;